// Whole minutes left on a grant, kept current (#10718).
import { useEffect, useState } from "react";
import { minutesLeft } from "@/hooks/useStaffGrant";
import {
  clearProductInterval,
  setProductInterval,
} from "@/utils/productTimers";

const TICK_MS = 30_000;

export function useMinutesLeft(expiresAt: string): number {
  const [minutes, setMinutes] = useState<number>(() => minutesLeft(expiresAt));
  useEffect(() => {
    setMinutes(minutesLeft(expiresAt));
    const timer = setProductInterval(
      () => setMinutes(minutesLeft(expiresAt)),
      TICK_MS
    );
    return () => clearProductInterval(timer);
  }, [expiresAt]);
  return minutes;
}
